export default __webpack_public_path__ + "static/bg-boxes-d341f550f1f9f7447542b5a01bd00c73.webp";